import { render, staticRenderFns } from "./DocGroupsList.vue?vue&type=template&id=ff595a48&"
import script from "./DocGroupsList.vue?vue&type=script&lang=js&"
export * from "./DocGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports